// extracted by mini-css-extract-plugin
module.exports = {"detailSection":"DetailSection_detailSection__EtPIp","detailSection__inner":"DetailSection_detailSection__inner__lksja"};